var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, Vue } from 'vue-property-decorator';
import axios from '../setup/axios';
import { showAlert, showLoading } from '@/helpers';
import { trans } from '@/setup/locales';
let BreadDifferences = class BreadDifferences extends Vue {
    constructor() {
        super(...arguments);
        this.loaded = false;
        this.recipes = [];
        this.tourGroup = null;
        this.date = null;
        this.clientsRecipes = [];
        this.hasChanges = true;
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.load();
        });
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            showLoading(true);
            const { data: { today, tour_group, recipes, clientsRecipes }, } = yield axios.get('/worker/breads/numbers/data');
            Object.assign(this, {
                date: today,
                recipes,
                tourGroup: tour_group,
                clientsRecipes
            });
            this.loaded = true;
            showLoading(false);
        });
    }
    post() {
        return __awaiter(this, void 0, void 0, function* () {
            showLoading(true);
            const data = {};
            let valid = true;
            const refs = this.$refs.differences;
            for (const difference of refs) {
                difference.markValid();
                if (difference.hasChange()) {
                    if (!difference.isValid()) {
                        difference.markInvalid();
                        valid = false;
                    }
                    const { recipe, quantity } = difference.get();
                    data[recipe] = quantity;
                }
            }
            if (!valid) {
                showLoading(false);
                yield showAlert(trans('breads.error_fields'));
                return;
            }
            const { data: { recipes, clientsRecipes } } = yield axios.post(`/worker/breads/numbers/${this.tourGroup}`, { data });
            Object.assign(this, { recipes, clientsRecipes });
            this.hasChanges = true;
            showLoading(false);
        });
    }
};
BreadDifferences = __decorate([
    Component
], BreadDifferences);
export default BreadDifferences;
